import Config from "../config/config";
import axios from "axios";

const { baseURL } = Config.API;

export const getOrders = (queryParams) => {
  return axios({
    method: 'GET',
    baseURL,
    url: '/orders',
    params: queryParams
  });
};

export const getOrder = (orderId) => {
  return axios({
    method: 'GET',
    baseURL,
    url: `/orders/${orderId}`
  });
};

export const addOrder = (data) => {
  return axios({
    method: 'POST',
    baseURL,
    url: '/orders',
    data,
  });
};

export const updateOrder = ({ orderId, ...otherData }) => {
  return axios({
    method: 'PATCH',
    baseURL,
    url: `/orders/${orderId}`,
    data: otherData,
  });
};

export default {
  getOrders,
  getOrder,
  addOrder,
  updateOrder,
};
